/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:59:00
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/transition.js
 */
export default {
    // transition动画组件的props
    transition: {
        show: false,
        mode: 'fade',
        duration: '300',
        timingFunction: 'ease-out'
    }
}
